import { Box } from '@chakra-ui/react';

const Menu = () => {
  return (
    <Box
      as="nav"
      bg="black" // Fondo negro
      color="white" // Letras blancas
      p={4}
    >
    </Box>
  );
};

export default Menu;
